import Fingerprint2 from 'fingerprintjs2';
import { FieldType, CompareType } from '../store/entities/filter';
import appconst from './AppConsts';
var Util = /** @class */ (function () {
    function Util() {
    }
    Object.defineProperty(Util.prototype, "BrowserIdentity", {
        get: function () {
            var identity = abp.utils.getCookieValue('bs.identity');
            if (!identity) {
                identity = btoa(this.guid());
                var expDate = new Date();
                expDate.setFullYear(2099, 12, 31);
                abp.utils.setCookieValue('bs.identity', identity, expDate, '/');
            }
            return identity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Util.prototype, "BaseUrl", {
        get: function () {
            var baseUrl = process.env.BASE_URL || '';
            var currentHost = location.protocol + '//' + location.host;
            baseUrl = baseUrl === '/' ? currentHost : baseUrl;
            baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
            return baseUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Util.prototype, "ApiUrl", {
        get: function () {
            var apiUrl = process.env.VUE_APP_API_URL || '';
            apiUrl = apiUrl.endsWith('/') ? apiUrl : apiUrl + '/';
            return apiUrl;
        },
        enumerable: true,
        configurable: true
    });
    Util.prototype.guid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };
    Util.prototype.initBrowserIdentity = function () {
        return new Promise(function (resolve, reject) {
            new Fingerprint2().get(function (result, components) {
                Util.browserIdentity = result;
                var expDate = new Date();
                expDate.setFullYear(2099, 12, 31);
                abp.utils.setCookieValue('bs.identity', result, expDate, '/');
                resolve(result);
            });
        });
    };
    Util.prototype.loadScript = function (url) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.body.appendChild(script);
    };
    Util.prototype.string2Boolean = function (source) {
        if (typeof source === 'boolean') {
            return source;
        }
        if (typeof source === 'string') {
            return source.toLowerCase() === 'true';
        }
        return !!source;
    };
    Util.prototype.func2Promise = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var func = args.shift();
        if (!func || typeof (func) !== 'function') {
            throw new Error('function first arg is require and must be a string');
        }
        return new Promise(function (resolve, reject) {
            var result = func.apply(this, args);
            // 如果返回的是一个Promise,则
            if (result instanceof Promise) {
                result.then(function () {
                    resolve();
                }, function () {
                    reject();
                });
            }
            else {
                if (result) {
                    resolve();
                }
                else {
                    reject();
                }
            }
        });
    };
    Util.prototype.buildFilters = function (filters) {
        var _this = this;
        var fileswhere = [];
        filters.forEach(function (f) {
            var where = '';
            if (f.Type === FieldType.Number) {
                where = _this.buildNumber(f);
            }
            else if (f.Type === FieldType.String) {
                where = _this.buildString(f);
            }
            else if (f.Type === FieldType.Boolean) {
                where = _this.buildBoolean(f);
            }
            else if (f.Type === FieldType.DataRange || f.Type === FieldType.Date) {
                where = _this.buildDate(f);
            }
            else if (f.Type === FieldType.Enum) {
                where = _this.buildEnum(f);
            }
            if (where) {
                fileswhere.push(where);
            }
        });
        return fileswhere.join(' AND ');
    };
    Util.prototype.title = function (title) {
        var appname = appconst.AppName;
        // abp.localization.localize('AppName', appconst.localization.defaultLocalizationSourceName);
        var page = abp.localization.localize(title, appconst.localization.defaultLocalizationSourceName);
        if (page) {
            // window.document.title = appname + '--' + page;
            window.document.title = page;
        }
        else {
            // window.document.title = appname;
            window.document.title = '';
        }
    };
    Util.prototype.inOf = function (arr, targetArr) {
        var res = true;
        arr.forEach(function (item) {
            if (targetArr.indexOf(item) < 0) {
                res = false;
            }
        });
        return res;
    };
    Util.prototype.oneOf = function (ele, targetArr) {
        if (targetArr.indexOf(ele) >= 0) {
            return true;
        }
        else {
            return false;
        }
    };
    Util.prototype.showThisRoute = function (itAccess, currentAccess) {
        if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
            return this.oneOf(currentAccess, itAccess);
        }
        else {
            return itAccess === currentAccess;
        }
    };
    Util.prototype.getRouterObjByName = function (routers, name) {
        if (!name || !routers || !routers.length) {
            return null;
        }
        // debugger;
        var routerObj = null;
        for (var _i = 0, routers_1 = routers; _i < routers_1.length; _i++) {
            var item = routers_1[_i];
            if (item.name === name) {
                return item;
            }
            routerObj = this.getRouterObjByName(item.children, name);
            if (routerObj) {
                return routerObj;
            }
        }
        return null;
    };
    Util.prototype.toDefaultPage = function (routers, name, route, next) {
        var len = routers.length;
        var i = 0;
        var notHandle = true;
        while (i < len) {
            if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
                route.replace({
                    name: routers[i].children[0].name
                });
                notHandle = false;
                next();
                break;
            }
            i++;
        }
        if (notHandle) {
            next();
        }
    };
    Util.prototype.setCurrentPath = function (vm, name) {
        var _this = this;
        var title = '';
        var isOtherRouter = false;
        vm.$store.state.app.routers.forEach(function (item) {
            if (item.children.length === 1) {
                if (item.children[0].name === name) {
                    title = _this.handleTitle(vm, item);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
                }
            }
            else {
                item.children.forEach(function (child) {
                    if (child.name === name) {
                        title = _this.handleTitle(vm, child);
                        if (item.name === 'otherRouter') {
                            isOtherRouter = true;
                        }
                    }
                });
            }
        });
        var currentPathArr = [];
        if (name === 'home') {
            currentPathArr = [
                {
                    meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home')) },
                    path: 'admin/home',
                    name: 'home'
                }
            ];
        }
        else if ((name.indexOf('index') >= 0 || isOtherRouter) && name !== 'home') {
            currentPathArr = [
                {
                    meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home')) },
                    path: 'admin/home',
                    name: 'home'
                },
                {
                    meta: { title: title },
                    path: '',
                    name: name
                }
            ];
        }
        else {
            var currentPathObj = vm.$store.state.app.routers.filter(function (item) {
                if (item.children.length <= 1) {
                    return item.children[0].name === name || item.name === name;
                }
                else {
                    var i = 0;
                    var childArr = item.children;
                    var len = childArr.length;
                    while (i < len) {
                        if (childArr[i].name === name) {
                            return true;
                        }
                        i++;
                    }
                    return false;
                }
            })[0];
            if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
                currentPathArr = [
                    {
                        meta: { title: 'HomePage' },
                        path: 'admin/home',
                        name: 'home'
                    }
                ];
            }
            else if (currentPathObj.children &&
                currentPathObj.children.length <= 1 &&
                currentPathObj.name !== 'home') {
                currentPathArr = [
                    {
                        meta: { title: 'HomePage' },
                        path: 'admin/home',
                        name: 'home'
                    },
                    {
                        meta: { title: currentPathObj.meta.title },
                        path: '',
                        name: name
                    }
                ];
            }
            else {
                var childObj = currentPathObj.children.filter(function (child) {
                    return child.name === name;
                })[0];
                currentPathArr = [
                    {
                        meta: { title: 'HomePage' },
                        path: 'admin/home',
                        name: 'home'
                    },
                    {
                        meta: { title: currentPathObj.meta.title },
                        path: '',
                        name: ''
                    },
                    {
                        meta: { title: childObj.meta.title },
                        path: currentPathObj.path + '/' + childObj.path,
                        name: name
                    }
                ];
            }
        }
        vm.$store.commit('app/setCurrentPath', currentPathArr);
        return currentPathArr;
    };
    Util.prototype.handleTitle = function (vm, item) {
        if (typeof item.meta.title === 'object') {
            return vm.$t(item.title.i18n);
        }
        else {
            return item.meta.title;
        }
    };
    Util.prototype.fullscreenEvent = function (vm) {
        vm.$store.commit('app/initCachepage');
        // 权限菜单过滤相关
        vm.$store.commit('app/updateMenulist');
        // 全屏相关
    };
    Util.prototype.extend = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var options;
        var src;
        var srcType;
        var copy;
        var copyIsArray;
        var clone;
        var target = args[0] || {};
        var i = 1;
        var length = args.length;
        var deep = false;
        if (typeof target === 'boolean') {
            deep = target;
            target = args[i] || {};
            i++;
        }
        if (typeof target !== 'object' && typeof target !== 'function') {
            target = {};
        }
        if (i === length) {
            target = this;
            i--;
        }
        for (; i < length; i++) {
            options = args[i];
            if (options !== null) {
                for (var name in options) {
                    if (options.hasOwnProperty(name)) {
                        src = target[name];
                        copy = options[name];
                        if (target === copy) {
                            continue;
                        }
                        srcType = Array.isArray(src) ? 'array' : typeof src;
                        copyIsArray = Array.isArray(copy);
                        if (deep && copy && (copyIsArray || typeof copy === 'object')) {
                            if (copyIsArray) {
                                copyIsArray = false;
                                clone = src && srcType === 'array' ? src : [];
                            }
                            else {
                                clone = src && srcType === 'object' ? src : {};
                            }
                            target[name] = this.extend(deep, clone, copy);
                        }
                        else if (copy !== undefined) {
                            target[name] = copy;
                        }
                    }
                }
            }
        }
        return target;
    };
    Util.prototype.buildDate = function (filter) {
        if (filter.Type === FieldType.Date) {
            if (!!filter.Value) {
                var compare = this.caseCompare(filter.CompareType);
                var date = new Date(filter.Value);
                return "" + filter.FieldName + compare + " DateTime(" + date.getFullYear() + "," +
                    (date.getMonth() + 1 + "," + date.getDate() + ")");
            }
            else {
                return '';
            }
        }
        else if (filter.Type === FieldType.DataRange) {
            if (!!filter.Value) {
                var dates = filter.Value;
                if (dates.length !== 2) {
                    throw new Error('Dates format is error');
                }
                else if (dates[0] && dates[1]) {
                    return "(" + filter.FieldName + ">= DateTime(" + dates[0].getFullYear() +
                        ("," + (dates[0].getMonth() + 1) + "," + dates[0].getDate() + ") AND") +
                        (" " + filter.FieldName + "<= DateTime(" + dates[1].getFullYear() + ",") +
                        (dates[1].getMonth() + 1 + "," + dates[1].getDate() + "))");
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    };
    Util.prototype.buildEnum = function (filter) {
        var compare = this.caseCompare(filter.CompareType);
        return "" + filter.FieldName + compare + "\"" + filter.Value + "\"";
    };
    Util.prototype.buildBoolean = function (filter) {
        if (filter.Value == null) {
            return '';
        }
        else if (filter.Value) {
            return filter.FieldName + "=true";
        }
        else if (!filter.Value) {
            return filter.FieldName + "=false";
        }
        else {
            return '';
        }
    };
    Util.prototype.buildString = function (filter) {
        if (!filter.Value) {
            return '';
        }
        var compare = this.caseCompare(filter.CompareType);
        return "" + filter.FieldName + compare + "(\"" + filter.Value + "\")";
    };
    Util.prototype.buildNumber = function (filter) {
        var compare = this.caseCompare(filter.CompareType);
        return "" + filter.FieldName + compare + filter.Value;
    };
    Util.prototype.caseCompare = function (compareType) {
        switch (compareType) {
            case CompareType.Greater:
                return '>';
            case CompareType.Less:
                return '<';
            case CompareType.Equal:
                return '=';
            case CompareType.GreaterOrEqual:
                return '>=';
            case CompareType.LessOrEqual:
                return '<=';
            case CompareType.Contains:
                return '.Contains';
            case CompareType.StartWith:
                return '.StartWith';
            case CompareType.EndWith:
                return '.EndWith';
            case CompareType.NotEqual:
                return '!=';
        }
    };
    return Util;
}());
var util = new Util();
export default util;
